import * as React from 'react';
import xClass from 'utils/xClass';

interface DivPictureProps {
	src: string
}

interface DivPictureState {
	imageCache: ImageCacheObject,
	ready: boolean
}

interface ImageCacheObject{
	[src: string]: {
		loading: false | true | null,
		img?: HTMLImageElement
	}
}


export default class DivPicture extends React.Component<DivPictureProps, DivPictureState>{
	constructor(props){
		super(props);
		this.state = {
			imageCache: {},
			ready: false
		};
	}

	static getDerivedStateFromProps(nextProps, prevState){
		let {imageCache} = prevState;
		return imageCache[nextProps.src] ? null : {
			...prevState,
			ready: false,
			imageCache: {
				...imageCache,
				[nextProps.src]: { loading: false }
			}
		}
	}

	componentDidUpdate(prevProps, prevState){
		let {imageCache} = this.state;
		for (var src in imageCache){
			if (imageCache[src].loading === false){
				imageCache[src].img = new Image();
				imageCache[src].img.onload = function(image){
					this.setState(state => ({
						...state,
						ready: true,
						imageCache: {
							...state.imageCache,
							[src]: {loading: null, img: image}
						}
					}));
				}.bind(this);
				imageCache[src].img.src = src;
			}
		}
	}
	render(){
		let {src} = this.props;
		let {ready} = this.state;

		return (
			<div
				className={xClass(
					'div-picture',
					{loading: !ready}
				)}
				style={{
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'contain',
					backgroundPosition: 'center',
					backgroundImage: ready ? `url(${src})` : undefined,
					width: '100%',
					height: '100%',
					top: 0,
					left: 0,
					bottom: 0,
					right: 0
				}}
			/>
		);
	}

}
